import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qba2f8n5gh: FaireBrandEntity = {
  token: "b_qba2f8n5gh",
  type: "brand",
  name: "Copper Pearl",
  avatarUrl:
    "https://cdn.faire.com/fastly/59db8b563deda0c414fddb57685ba718dd0fc74425afabb4bf3377289f96d82c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/720ba8b149a13857b60c31b37e7c4be2308c76de0445ccfdf814bbf28a469b8e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/59db8b563deda0c414fddb57685ba718dd0fc74425afabb4bf3377289f96d82c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/720ba8b149a13857b60c31b37e7c4be2308c76de0445ccfdf814bbf28a469b8e.png",
  location: "Salt Lake, UT, USA",
  minimumOrderDollars: 300,
  rating: 5,
  reviewCount: 9,
  isInsider: true,
  description:
    "Everyday Essentials, Elevated.\nAt Copper Pearl, we set out with one simple idea: make everyday essentials feel anything but ordinary. What started with drool-absorbing bibs has grown into a thoughtfully designed collection of trusted basics—accessories, apparel, bath, and nursery gear—crafted to deliver comfort, style, and quality that lasts.\n\nOur fan-favorite Signature Jersey is the heartbeat of the brand, loved for its softness, durability, and perfect stretch. Paired with exclusive prints and colors you won’t find anywhere else, Copper Pearl brings families the stylish, practical essentials they reach for every single day.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:21.860Z",
    importedBy: "entity-db-cli",
  },
};
